<script lang="ts">
  import { push } from 'svelte-spa-router';
  import { Tabs, Tab } from 'svelte-materialify';

  import Page from '../Page.svelte';
  import Scroller from '../Scroller.svelte';
  import DistinctUsers from './DistinctUsers.svelte';
  import ProjectUsers from './ProjectUsers.svelte';

  export let params: { project: string; distinct: boolean };

  let userCount = 0;

  $: isDistinct = !!params.distinct;

  function navigate(distinct: boolean) {
    const path = `/project/${params.project}/users${distinct ? '/distinct' : ''}`;

    userCount = 0;

    push(path);
  }

  function onUserCount(evt: any) {
    userCount = evt.detail;
  }
</script>

<Page title="Users" subtitle={`(${userCount})`}>
  <Scroller>
    <Tabs value={isDistinct ? 1 : 0} grow class="green-text">
      <div slot="tabs">
        <Tab value={0} on:click={() => navigate(false)}>Registered Users</Tab>
        <Tab value={1} on:click={() => navigate(true)}>Distincts</Tab>
      </div>
    </Tabs>
    {#if isDistinct}
      <DistinctUsers project={params.project} on:user-count={onUserCount} />
    {:else}
      <ProjectUsers project={params.project} on:user-count={onUserCount} />
    {/if}
  </Scroller>
</Page>
